import { useWorkspaceId } from "../../workspace/useWorkspaceId";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import {
    BASE_API_URL,
    HttpError,
} from "../utils/useGovernmentAgencyHubAppQueryClient";
import { useHttpGovernmentAgencyHubAppHeaders } from "../utils/useHttpGovernmentAgencyHubAppHeaders";
import type { DelegatedDTO } from "./DelegatedDTO";

export function useGetDelegated(intermediaryTaxId: string) {
    const workspaceId = useWorkspaceId();
    const headers = useHttpGovernmentAgencyHubAppHeaders();
    const { t } = useTranslation();

    const query = useQuery<DelegatedDTO[]>({
        queryKey: ["delegated", workspaceId, intermediaryTaxId],
        queryFn: async () => {
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/intermediaries/${intermediaryTaxId}/delegated`,
                {
                    headers,
                },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }

            return response.json();
        },
        enabled: !!workspaceId,
        meta: {
            resourceName: t("errors.resourceName.delegated"),
        },
    });

    return query;
}
